import { render, staticRenderFns } from "./DoctorSverka.vue?vue&type=template&id=97ddc0b2&scoped=true"
import script from "./DoctorSverka.vue?vue&type=script&lang=js"
export * from "./DoctorSverka.vue?vue&type=script&lang=js"
import style0 from "./DoctorSverka.vue?vue&type=style&index=0&id=97ddc0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ddc0b2",
  null
  
)

export default component.exports